<template lang="pug">
div
  app-modal-visualizar-historico(
    v-if="showModal && idProcesso !== null",
    @closeModal="showModal = false",
    :historicoList="historicoList",
    :idProcesso="idProcesso"
    :titulo="tipoProcesso"
  )
  div.main.hidden-xs-only
    el-table(
      :data='processos',
      v-loading="loading",
      element-loading-text="Carregando..."
      @sort-change="changeOrder"
    )
      template(slot="empty") Não há registros.
      el-table-column(
        prop='numeroProcesso',
        label='Processo',
        width="auto"
      )
      el-table-column(
        prop='setor',
        label='Setor',
        width="auto"
      )
      el-table-column(
        prop='nomeRazaoSocialInteressado',
        label='Nome do interessado',
        width="auto"
      )
      el-table-column(
        prop='tipo.nome',
        label='Tipo de processo',
        width="auto"
      )
      el-table-column(
        prop='municipioFormatado',
        label='Município',
        width="auto"
      )
      el-table-column(
        label='Ações',
        width='120',
        align='center'
      )
        template(slot-scope='scope')
          el-dropdown(trigger="click")
            el-button(type='primary', size="small")
              | Ações
              i.el-icon-arrow-down.el-icon--right
            el-dropdown-menu(slot='dropdown')
              el-dropdown-item
                .flex(@click="abreModal(scope.row)")
                  i.fa.fa-eye
                  | &nbsp Visualizar processo
  div.pagination
     app-paginacao(
        :total="totalItems"
        :pagina="currentPage",
        @changePage="changePage",
        :tamanhoPagina="pageSize"
      )
</template>

<script>
import { mapActions } from 'vuex'
import EnumFormatter from '@/utils/EnumFormatter'
import AppListagemRelatorio from '@/screens/portal/publico/components/Consulta.vue'
import AppPaginacao from '@/components/AppPaginacao'
import AppModalVisualizarHistorico from './AppModalVisualizarHistoricoProcesso.vue'

export default {

  components: {
    AppListagemRelatorio,
    AppPaginacao,
    AppModalVisualizarHistorico
  },

  data () {
    return {
      idProcesso: null,
      tipoProcesso: '',
      showModal: false,
      historicoList: []
    }
  },

  props: {
    processos: {
      type: Array,
      required: true
    },
    pageSize: {
      type: Number,
      default: 15
    },
    totalItems: {
      type: Number,
      required: true
    },
    loading: {
      Type: Boolean,
      default: false
    },
    currentPage: {
      Type: Number,
      default: 1
    }
  },

  methods: {
    ...mapActions({
      getHistoricoProcessoPublico: 'processos/getHistoricoProcessoPublico'
    }),

    changePage (newPage) {
      return this.$emit('changePage', newPage)
    },
    getStatusFormatado (row) {
      return EnumFormatter.getStatusFormatado(row.status, row.setor)
    },
    getCpfCnpjInteressado (row) {
      if (row.cpfCnpjInteressado) {
        return row.cpfCnpjInteressado
      }
      return '-'
    },
    isVerificaMunicipio (prop, column, row) {
      return row[0] && row[0].municipios && row[0].municipios.length > 0 ? row[0].municipios[0].nome : '-'
    },

    async abreModal (processo) {
      this.idProcesso = processo.id
      this.tipoProcesso = processo.tipo.nome
      const response = await this.getHistoricoProcessoPublico(processo.id)
      this.historicoList = response
      this.showModal = true
    },

    changeOrder (column) {
      this.$emit('changeOrder', column)
    }
  }
}
</script>
<style lang="scss" scoped>

  .main {
    padding-top: 10px;
  }
  .pagination {
    text-align: center;
  }
  .align-center {
    text-align: center;
  }

  @media screen and (max-width: 1023px) {
    .hidden-sm {
      display: none;
    }
  }

  .row {
    border-bottom: 1px solid #ebeef5;
    font-weight: bold;
    font-size: 12px;
    span {
      margin-left: 5px;
      font-weight: normal;
    }
  }

  .row:first-child {
    border-top: 1px solid #ebeef5;
    margin-top: 30px;
  }

</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/components/ConsultaListagemProcessos.vue